/* eslint-disable */

/** unique or primary key constraints on table "argo.attribute_history_status_type" */
export enum ArgoAttributeHistoryStatusTypeConstraint {
  /** unique or primary key constraint on columns "status" */
  AttributeHistoryStatusTypePkey = 'attribute_history_status_type_pkey'
}

export enum ArgoAttributeHistoryStatusTypeEnum {
  /** Attribute added to item */
  Added = 'added',
  /** Attribute removed from item */
  Removed = 'removed',
  /** Attribute updated on item */
  Updated = 'updated'
}

/** select columns of table "argo.attribute_history_status_type" */
export enum ArgoAttributeHistoryStatusTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** update columns of table "argo.attribute_history_status_type" */
export enum ArgoAttributeHistoryStatusTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

